import React from 'react';

import { HN_SKJEMA_FRONTEND_RESOURCES } from 'src/constants/constants';
import { useResources } from 'src/resources';
import { useAppSelector } from 'src/store/reducers';
import { useGetErrorMessageFromErrorCode } from 'src/store/selectors/errorCodesSelectors';

import type { HNSkjemaErrorCodes, HNSkjemaFrontend } from '../../types/Resources';

import NotificationPanel from '@helsenorge/designsystem-react/components/NotificationPanel';

const SkjemaLoadError = (): React.JSX.Element => {
  const resources = useResources<HNSkjemaFrontend>(HN_SKJEMA_FRONTEND_RESOURCES);
  const loadSkjemaoppgaveErrorMessage = useAppSelector(state => state.refero.ui.loadSkjemaoppgaveErrorMessage) as keyof HNSkjemaErrorCodes;
  const loadSkjemaErrorCode = useAppSelector(state => state.refero.ui.loadSkjemaoppgaveErrorCode) as keyof HNSkjemaFrontend | undefined;
  const errorMessage = useGetErrorMessageFromErrorCode(loadSkjemaErrorCode);

  const description = errorMessage ?? loadSkjemaoppgaveErrorMessage;

  return (
    <section className="defaultspacing" data-testid="skjema-load-error">
      <NotificationPanel testId="notification-skjema-load-error" variant="error" role="alert" label={resources?.loadSkjemaErrorTitle}>
        {description}
      </NotificationPanel>
    </section>
  );
};

export default SkjemaLoadError;
